import React from 'react';
import { useState, useEffect, useRef, useMemo, useCallback } from "react"
import { TT, CL, GP, ROOM_TYPES, BILL_TYPES, SUPA_URL, SUPA_KEY } from "../constants.js";
import { fd, feur, effSt, getBreaks, prixNuitee as prixNuiteeHelper, contratActif } from "../utils.js";
import { Ic } from "./Ic.jsx";
import { M } from "./M.jsx";
import { supaGet, supaSet, useSt, SUPA_TOKEN, sendAccessEmail } from "../supabase.js";
import { BienWizard, FichePrepaModal } from "./SecPrest.jsx";
import { WeekPlan, caTask } from "./TaskForm.jsx";
import { generateFacturX, bytesToBase64 } from "../facturxCore.js";


// ══════════════ SECTION PROPRIÉTAIRES ══════════════
function SecProp(P){
  const{clients,setClients,biens,setBiens,biensLoaded,pj,st,staff,gerants,rep,als,req,setReq,viewAs}=P;
  const[sub,setSub]=useState('cli');
  const[editC,setEditC]=useState(null);
  const[editB,setEditB]=useState(null); // {bien ou {}, prefillCid?}
  const[fichePrepa,setFichePrepa]=useState(null); // bien obj
  const saveC=d=>{if(d.id)setClients(clients.map(c=>c.id===d.id?d:c));else setClients([...clients,{...d,id:'c'+Date.now(),firstLogin:true}]);setEditC(null);};
  const delC=async cli=>{
    const bs=biens.filter(b=>b.cid===cli.id).length;
    const rs=req.filter(r=>r.cid===cli.id).length;
    let msg=`Supprimer définitivement "${cli.name||'ce propriétaire'}" ?\n\nCette action est irréversible.`;
    if(bs>0||rs>0){
      msg+=`\n\n⚠️ Attention, ce propriétaire est lié à :`;
      if(bs>0)msg+=`\n• ${bs} appartement(s)`;
      if(rs>0)msg+=`\n• ${rs} demande(s)`;
      msg+=`\n\nLes appartements existeront toujours mais sans propriétaire associé. Tu pourras les réassigner ensuite.`;
    }
    if(!window.confirm(msg))return;
    const current=await supaGet('clients7')||[];
    const updated=current.filter(c=>c.id!==cli.id);
    await supaSet('clients7',updated);
    setClients(updated);
    setEditC(null);
  };
  const saveB=async d=>{
    setEditB(null);
    const current=await supaGet('biens8')||[];
    const exists=current.some(b=>b.id===d.id);
    const updated=exists?current.map(b=>b.id===d.id?d:b):[...current,d];
    await supaSet('biens8',updated);
    setBiens(updated);
  };
  const delB=async bien=>{
    // Vérifier les références : tâches planning, jobs prestataires, demandes propriétaires
    const tasksLies=st.filter(t=>t.bid===bien.id).length;
    const jobsLies=pj.filter(j=>j.bid===bien.id).length;
    const reqsLies=req.filter(r=>r.bid===bien.id).length;
    let msg=`Supprimer définitivement "${bien.name}" ?\n\nCette action est irréversible.`;
    if(tasksLies>0||jobsLies>0||reqsLies>0){
      msg+=`\n\n⚠️ Attention, ce bien est lié à :`;
      if(tasksLies>0)msg+=`\n• ${tasksLies} tâche(s) planning`;
      if(jobsLies>0)msg+=`\n• ${jobsLies} job(s) prestataire`;
      if(reqsLies>0)msg+=`\n• ${reqsLies} demande(s) propriétaire`;
      msg+=`\n\nCes éléments resteront mais perdront leur lien avec le bien.`;
    }
    if(!window.confirm(msg))return;
    const current=await supaGet('biens8')||[];
    const updated=current.filter(b=>b.id!==bien.id);
    await supaSet('biens8',updated);
    setBiens(updated);
  };

  // Si le wizard est ouvert → full-screen overlay
  if(editB!==null){
    return(
      <div style={{position:'fixed',inset:0,zIndex:90,overflowY:'auto',background:'var(--bg)'}}>
        <BienWizard
          b={editB.id?editB:null}
          clients={clients}
          rep={rep}
          prefillCid={editB._prefillCid||null}
          onSave={saveB}
          onC={()=>setEditB(null)}
        />
      </div>
    );
  }

  return(<div>
    <div className="stabs">
      <button className={`st ${sub==='cli'?'on':''}`} onClick={()=>setSub('cli')}><Ic n="u1"/>Propriétaires</button>
      <button className={`st ${sub==='apt'?'on':''}`} onClick={()=>setSub('apt')}><Ic n="h"/>Appartements</button>
      <button className={`st ${sub==='fac'?'on':''}`} onClick={()=>setSub('fac')}><Ic n="eu"/>Préparation facturation</button>
    </div>

    {sub==='cli'&&(<div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:14,flexWrap:'wrap',gap:8}}>
        <div className="D" style={{fontSize:18}}>Propriétaires</div>
        <button onClick={()=>setEditC({})} className="btn bpk sm"><Ic n="plus"/>Nouveau</button>
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:14}}>
        {clients.map(c=>{
          const cB=biens.filter(b=>b.cid===c.id);
          return(<div key={c.id} className="card" style={{padding:'16px 18px',borderTop:'3px solid var(--pk)'}}>
            {/* En-tête propriétaire */}
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:10,flexWrap:'wrap',gap:8}}>
              <div className="D" style={{fontSize:16,color:'var(--pk)'}}>{c.name}</div>
              <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                {viewAs&&<button onClick={()=>viewAs('client',c.id)} className="btn bgh sm" style={{fontSize:11}}>👁️ Voir comme</button>}
                <button
                  onClick={()=>{
                    if(!window.confirm(`Forcer ${c.name} (accès principal) à choisir un nouveau mot de passe à sa prochaine connexion ?`))return;
                    const em=(c.email||'').trim().toLowerCase();
                    setClients(clients.map(x=>{
                      if(x.id!==c.id)return x;
                      const list=Array.isArray(x.firstLoginEmails)?x.firstLoginEmails.slice():[];
                      if(em&&!list.map(e=>(e||'').trim().toLowerCase()).includes(em))list.push(em);
                      return{...x,firstLoginEmails:list};
                    }));
                  }}
                  className="btn bgh sm"
                  title="Forcer le changement de MDP de l'accès principal à la prochaine connexion"
                  style={{fontSize:11,color:'#b45309'}}
                >🔑 MDP</button>
                <button
                  onClick={async()=>{
                    const em=(c.email||'').trim();
                    if(!em){alert('Ce propriétaire n’a pas d’email renseigné.');return;}
                    if(!window.confirm(`Envoyer l’email de définition de mot de passe à ${em} ?\n\nLe propriétaire recevra un lien sécurisé pour choisir son mot de passe et accéder à son espace.`))return;
                    try{
                      await sendAccessEmail(em);
                      alert(`✅ Email envoyé à ${em}.`);
                    }catch(e){alert('❌ '+(e.message||'Échec de l’envoi.'));}
                  }}
                  className="btn bgh sm"
                  title="Envoyer le lien d'accès par email (définition du mot de passe)"
                  style={{fontSize:11,color:'var(--mn)'}}
                >📧 Envoyer l'accès</button>
                <button onClick={()=>setEditC(c)} className="btn bgh sm"><Ic n="edit" c="w-3.5 h-3.5"/>Modifier</button>
                <button onClick={()=>delC(c)} className="btn bgh sm" style={{color:'var(--dg)'}} title="Supprimer">🗑️</button>
              </div>
            </div>
            {/* Coordonnées */}
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:6,fontSize:12,marginBottom:12}}>
              {[['Email',c.email||'—'],['Tél.',c.phone||'—'],['Adresse',[c.addr,c.cp&&c.ville?c.cp+' '+c.ville:c.cp||c.ville||''].filter(Boolean).join(', ')||'—'],['SIRET',c.siret||'—'],['N° TVA',c.tva||'—'],['Taux services',c.mgr?`${c.mgr}%`:'—']].map(([k,v],i)=>(<div key={i} style={{background:'var(--bg)',borderRadius:6,padding:'5px 8px'}}><div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>{k}</div><div style={{fontWeight:600,fontSize:11}}>{v}</div></div>))}
            </div>
            {/* Accès secondaires (secrétaire, comptable…) */}
            {Array.isArray(c.accesSecondaires)&&c.accesSecondaires.length>0&&(
              <div style={{background:'var(--bg)',borderRadius:8,padding:'8px 10px',marginBottom:12}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)',marginBottom:6}}>Accès secondaires</div>
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  {c.accesSecondaires.map((a,i)=>{
                    const em=(a.email||'').trim().toLowerCase();
                    const pending=Array.isArray(c.firstLoginEmails)&&c.firstLoginEmails.map(e=>(e||'').trim().toLowerCase()).includes(em);
                    return(<div key={i} style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap',fontSize:11}}>
                      <span style={{fontWeight:600}}>{a.label||'Accès'}</span>
                      <span style={{color:'var(--si)'}}>{a.email||'—'}</span>
                      <span style={{color:'var(--si)',fontStyle:a.prenom?'normal':'italic'}}>👋 {a.prenom?`Bonjour ${a.prenom}`:'accueil neutre'}</span>
                      {pending&&<span style={{background:'#fef3c7',color:'#b45309',fontSize:9,fontWeight:700,padding:'1px 7px',borderRadius:999}}>MDP à choisir</span>}
                      <button
                        onClick={()=>{
                          if(!em){alert('Renseignez d’abord un email pour cet accès.');return;}
                          if(!window.confirm(`Forcer « ${a.label||'cet accès'} » (${a.email}) à choisir un nouveau mot de passe à sa prochaine connexion ?`))return;
                          setClients(clients.map(x=>{
                            if(x.id!==c.id)return x;
                            const list=Array.isArray(x.firstLoginEmails)?x.firstLoginEmails.slice():[];
                            if(!list.map(e=>(e||'').trim().toLowerCase()).includes(em))list.push(em);
                            return{...x,firstLoginEmails:list};
                          }));
                        }}
                        className="btn bgh sm"
                        title="Forcer le changement de MDP de cet accès"
                        style={{fontSize:10,color:'#b45309',padding:'3px 8px'}}
                      >🔑 MDP</button>
                      <button
                        onClick={async()=>{
                          if(!em){alert('Renseignez d’abord un email pour cet accès.');return;}
                          if(!window.confirm(`Envoyer l’email de définition de mot de passe à ${a.email} ?`))return;
                          try{
                            await sendAccessEmail(em);
                            alert(`✅ Email envoyé à ${a.email}.`);
                          }catch(er){alert('❌ '+(er.message||'Échec de l’envoi.'));}
                        }}
                        className="btn bgh sm"
                        title="Envoyer le lien d'accès par email"
                        style={{fontSize:10,color:'var(--mn)',padding:'3px 8px'}}
                      >📧 Accès</button>
                    </div>);
                  })}
                </div>
              </div>
            )}
            <div style={{borderTop:'1px solid var(--li)',paddingTop:12}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                <div style={{fontSize:12,fontWeight:700,color:'var(--si)'}}>🏠 Appartements ({cB.length})</div>
                <button onClick={()=>setEditB({_prefillCid:c.id})} className="btn bor sm"><Ic n="plus"/>Ajouter un bien</button>
              </div>
              {cB.length===0&&<div style={{fontSize:12,color:'var(--si)',fontStyle:'italic',paddingBottom:4}}>Aucun appartement pour ce propriétaire.</div>}
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))',gap:10}}>
                {cB.map(b=>(
                  <div key={b.id} style={{background:'var(--bg)',borderRadius:10,padding:'10px 12px',border:'1px solid var(--li)'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:6}}>
                      <div className="D" style={{fontSize:14}}>{b.name}</div>
                      <div style={{display:'flex',gap:4}}>
                        <button onClick={()=>setEditB(b)} className="btn bgh sm" style={{padding:'4px 8px',fontSize:11}} title="Modifier"><Ic n="edit" c="w-3 h-3"/></button>
                        <button onClick={()=>delB(b)} className="btn bgh sm" style={{padding:'4px 8px',fontSize:11,color:'var(--dg)'}} title="Supprimer">🗑️</button>
                      </div>
                    </div>
                    <div style={{fontSize:11,color:'var(--si)',marginBottom:6,lineHeight:1.4}}>{b.addr||'—'}</div>
                    <div style={{display:'flex',gap:5,flexWrap:'wrap',marginBottom:7}}>
                      {b.pieces&&<span style={{background:'var(--cr)',fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:999}}>{b.pieces}</span>}
                      {b.sqm&&<span style={{background:'var(--cr)',fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:999}}>{b.sqm}m²</span>}
                      {b.cp&&<span style={{background:'#e1f7ee',color:'#2d6b3e',fontSize:10,fontWeight:600,padding:'2px 7px',borderRadius:999}}>{feur(Number(b.cp))}</span>}
                    </div>
                    <button onClick={()=>setFichePrepa(b)} className="btn bor sm" style={{width:'100%',justifyContent:'center',fontSize:11}}>📋 Fiche préparation</button>
                  </div>
                ))}
              </div>
            </div>
          </div>);
        })}
      </div>
      {editC!==null&&<M onC={()=>setEditC(null)} title={editC.id?'Modifier':'Nouveau propriétaire'} col="var(--pk)" ch={<ClientForm c={editC.id?editC:null} biens={biens} onSave={saveC} onC={()=>setEditC(null)}/>}/>}
    </div>)}

    {sub==='apt'&&(<div>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:14,flexWrap:'wrap',gap:8}}>
        <div className="D" style={{fontSize:18}}>Tous les appartements</div>
        <button onClick={()=>setEditB({})} className="btn bor sm"><Ic n="plus"/>Nouveau bien</button>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:12}}>
        {biens.map(b=>{
          const c=clients.find(x=>x.id===b.cid);
          const equips=[...(b.cuisine||[]),...(b.sdbEquip||[]),...(b.autres||[])];
          return(<div key={b.id} className="card" style={{padding:'14px 16px',borderTop:'3px solid var(--or)'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:8}}>
              <div>
                <div className="D" style={{fontSize:15}}>{b.name}</div>
                {c&&<div style={{fontSize:11,color:'var(--pk)',fontWeight:600,marginTop:1}}>👤 {c.name}</div>}
              </div>
              <div style={{display:'flex',gap:4}}>
                <button onClick={()=>setEditB(b)} className="btn bgh sm" title="Modifier"><Ic n="edit" c="w-3.5 h-3.5"/></button>
                <button onClick={()=>delB(b)} className="btn bgh sm" style={{color:'var(--dg)'}} title="Supprimer">🗑️</button>
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:5,fontSize:12,marginBottom:7}}>
              {[
                ['Adresse',b.addr||'—'],
                ['Code',b.codeType==='regulier'?b.code||'Régulier':'Ponctuel'],
                ['Ménage',b.cp?feur(Number(b.cp)):'—'],
                ['Type',b.pieces?`${b.pieces}${b.sqm?' · '+b.sqm+'m²':''}`:b.sqm?b.sqm+'m²':'—'],
                ['Étage',b.etage!==undefined&&b.etage!==''?`Ét. ${b.etage}${b.ascenseur?' 🛗':''}`:b.duplex?'Duplex':'—'],
                ['Géo',`${b.gr||150}m`],
              ].map(([k,v],i)=>(<div key={i} style={{background:'var(--bg)',borderRadius:6,padding:'5px 7px'}}><div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>{k}</div><div style={{fontWeight:600,fontSize:11}}>{v}</div></div>))}
            </div>
            {equips.length>0&&<div style={{display:'flex',flexWrap:'wrap',gap:3,paddingTop:7,borderTop:'1px solid var(--li)',marginBottom:8}}>{equips.slice(0,6).map(e=><span key={e} style={{background:'var(--cr)',fontSize:10,fontWeight:600,padding:'2px 6px',borderRadius:999}}>{e}</span>)}{equips.length>6&&<span style={{fontSize:10,color:'var(--si)'}}> +{equips.length-6}</span>}</div>}
            <button onClick={()=>setFichePrepa(b)} className="btn bor sm" style={{width:'100%',justifyContent:'center',fontSize:11,marginTop:4}}>📋 Fiche préparation</button>
          </div>);
        })}
      </div>
    </div>)}

    {sub==='fac'&&(()=>{
      // Calcul aligné avec WeekPlan via le helper caTask :
      // - uniquement les tâches "effectivement done" (via t.st OU via alias de pointage),
      //   affectées à un travailleur existant (salarié OU gérant)
      // - tarif selon type (cp / tarifCheckin / tarifCheckout / 0) + tarif urgent + majoration +25%
      // - + extras facturés via billTotal du rapport soumis
      const validStaffIds=new Set([...staff,...(gerants||[])].map(s=>s.id));
      const rowsFac=biens.map(b=>{
        const c=clients.find(x=>x.id===b.cid);
        const tasksDone=st.filter(t=>t.bid===b.id&&effSt(t,als)==='done'&&t.sid&&validStaffIds.has(t.sid));
        const tot=tasksDone.reduce((sum,t)=>sum+caTask(t,b,rep),0);
        return{b,c,count:tasksDone.length,tot};
      });
      const totalCA=rowsFac.reduce((s,r)=>s+r.tot,0);
      return(<div>
        <div className="D" style={{fontSize:18,marginBottom:8}}>Préparation à la facturation</div>
        <div style={{background:'#fff4d6',border:'1.5px solid var(--ye)',borderRadius:10,padding:'10px 14px',marginBottom:16,fontSize:12}}><strong>⚠ Module partiel</strong> — La facturation complète (services 15%, OTA, frais) sera développée lors de la prochaine itération. Les sous-traitances aux prestataires ne sont pas comptées dans le CA ci-dessous (à revoir).</div>
        <div style={{overflowX:'auto'}}>
          <table className="tbl">
            <thead><tr><th>Appartement</th><th>Propriétaire</th><th>Tâches facturées</th><th>Tarif ménage réf.</th><th>Sous-total</th><th>Statut</th></tr></thead>
            <tbody>
              {rowsFac.map(({b,c,count,tot})=>(<tr key={b.id}><td><strong>{b.name}</strong></td><td>{c?.name||'—'}</td><td>{count}</td><td>{feur(Number(b.cp)||0)}</td><td style={{fontWeight:700,color:'var(--or)'}}>{feur(tot)}</td><td><span className="pill pnd">Brouillon</span></td></tr>))}
            </tbody>
            <tfoot><tr><td colSpan={4} style={{textAlign:'right',paddingRight:12}}>Total</td><td colSpan={2}><strong style={{color:'var(--or)'}}>{feur(totalCA)}</strong></td></tr></tfoot>
          </table>
        </div>
      </div>);
    })()}

    {fichePrepa&&<M onC={()=>setFichePrepa(null)} title={`📋 Fiche préparation · ${fichePrepa.name}`} col="var(--or)" ch={<FichePrepaModal bien={fichePrepa} onClose={()=>setFichePrepa(null)}/>}/>}
  </div>);
}
function ClientForm({c,biens,onSave,onC}){
  const[f,setF]=useState(c||{name:'',enseigne:'',email:'',phone:'',addr:'',cp:'',ville:'',siret:'',tva:'',notes:'',mgr:15,profilFacturation:'gestion'});
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const acces=Array.isArray(f.accesSecondaires)?f.accesSecondaires:[];
  const setAcces=arr=>set('accesSecondaires',arr);
  const addAcces=()=>setAcces([...acces,{email:'',label:'',prenom:''}]);
  const updAcces=(i,k,v)=>setAcces(acces.map((a,j)=>j===i?{...a,[k]:v}:a));
  const rmAcces=i=>setAcces(acces.filter((_,j)=>j!==i));
  return(<div style={{display:'flex',flexDirection:'column',gap:10}}>
    {/* Profil de facturation : pilote l'interface client, le gabarit de facture et les regles.
        'gestion' = modele actuel (commission/reversement). 'prestations' = vente a l'unite (menage+check-in). */}
    <div style={{background:'#fff4d6',borderRadius:10,padding:'12px 14px',border:'1.5px solid var(--ye)'}}>
      <label className="fl" style={{marginBottom:6}}>Profil de facturation</label>
      <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
        {[
          {v:'gestion',label:'Service conciergerie',desc:'Versement OTA − frais de services (modèle actuel)'},
          {v:'prestations',label:'Prestations',desc:'Vente à l\u2019unité : ménages + check-in, sans %'},
        ].map(o=>(
          <div key={o.v} onClick={()=>set('profilFacturation',o.v)} style={{flex:'1 1 200px',cursor:'pointer',padding:'10px 12px',borderRadius:8,border:`2px solid ${(f.profilFacturation||'gestion')===o.v?'var(--or)':'var(--li)'}`,background:(f.profilFacturation||'gestion')===o.v?'#fff':'var(--bg)'}}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:16,color:(f.profilFacturation||'gestion')===o.v?'var(--or)':'var(--si)'}}>{(f.profilFacturation||'gestion')===o.v?'◉':'◯'}</span>
              <span style={{fontWeight:700,fontSize:13}}>{o.label}</span>
            </div>
            <div style={{fontSize:11,color:'var(--si)',marginTop:3,marginLeft:24,lineHeight:1.4}}>{o.desc}</div>
          </div>
        ))}
      </div>
    </div>

    {/* Indicateur visuel (donut) affiché en haut du Récap locations propriétaire */}
    <div style={{background:'var(--bg)',borderRadius:10,padding:'12px 14px',border:'1.5px solid var(--li)'}}>
      <label className="fl" style={{marginBottom:6}}>Indicateur visuel (Récap locations)</label>
      <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
        {[
          {v:'occ',label:'Taux d\u2019occupation',desc:'Nuitées / jours disponibles — pertinent en pleine saison'},
          {v:'conserv',label:'Part conservée',desc:'Revenu net / versé OTA — pertinent toute l\u2019année'},
          {v:'off',label:'Masqué',desc:'Aucun indicateur affiché'},
        ].map(o=>(
          <div key={o.v} onClick={()=>set('donutMetric',o.v)} style={{flex:'1 1 160px',cursor:'pointer',padding:'10px 12px',borderRadius:8,border:`2px solid ${(f.donutMetric||'occ')===o.v?'var(--or)':'var(--li)'}`,background:(f.donutMetric||'occ')===o.v?'#fff':'var(--bg)'}}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:16,color:(f.donutMetric||'occ')===o.v?'var(--or)':'var(--si)'}}>{(f.donutMetric||'occ')===o.v?'◉':'◯'}</span>
              <span style={{fontWeight:700,fontSize:13}}>{o.label}</span>
            </div>
            <div style={{fontSize:11,color:'var(--si)',marginTop:3,marginLeft:24,lineHeight:1.4}}>{o.desc}</div>
          </div>
        ))}
      </div>
    </div>
    {/* Sous-réglage prestations : mode de regroupement de la facture (Morceau 1).
        'semaine' (Delphine) = facture hebdo lundi→dimanche, colonne Jour, tri semaine/jour/rang bien.
        'periode' (Verissimo) = plage de dates libre, ménages urgents au PU majoré. Réglage explicite par client. */}
    {(f.profilFacturation==='prestations')&&(
      <div style={{background:'#eef4ff',borderRadius:10,padding:'12px 14px',border:'1.5px solid #bfdbfe'}}>
        <label className="fl" style={{marginBottom:6}}>Regroupement de la facture prestations</label>
        <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          {[
            {v:'semaine',label:'Par semaine',desc:'Facture hebdo (lundi → dimanche), colonne Jour, ordre par bien'},
            {v:'periode',label:'Par période',desc:'Plage de dates libre, ménages urgents possibles'},
          ].map(o=>(
            <div key={o.v} onClick={()=>set('modeRegroupement',o.v)} style={{flex:'1 1 200px',cursor:'pointer',padding:'10px 12px',borderRadius:8,border:`2px solid ${(f.modeRegroupement||'semaine')===o.v?'var(--or)':'var(--li)'}`,background:(f.modeRegroupement||'semaine')===o.v?'#fff':'var(--bg)'}}>
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <span style={{fontSize:16,color:(f.modeRegroupement||'semaine')===o.v?'var(--or)':'var(--si)'}}>{(f.modeRegroupement||'semaine')===o.v?'◉':'◯'}</span>
                <span style={{fontWeight:700,fontSize:13}}>{o.label}</span>
              </div>
              <div style={{fontSize:11,color:'var(--si)',marginTop:3,marginLeft:24,lineHeight:1.4}}>{o.desc}</div>
            </div>
          ))}
        </div>
        {/* Planning client : donne au propriétaire prestations un onglet planning en lecture seule
            (ses ménages à venir, heure de début, sans intervenant). Désactivé par défaut, activable
            au cas par cas pour éviter les abus (relances sur chaque créneau). */}
        <div style={{marginTop:12,paddingTop:12,borderTop:'1px dashed #bfdbfe'}}>
          <label style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer'}}>
            <input type="checkbox" checked={!!f.planningClient} onChange={e=>set('planningClient',e.target.checked)} style={{width:16,height:16,cursor:'pointer',flexShrink:0}}/>
            <span><strong style={{fontSize:13}}>📅 Donner accès au planning</strong>
              <span style={{display:'block',fontSize:11,color:'var(--si)',marginTop:2,lineHeight:1.4}}>Affiche un onglet « Planning » dans son espace : ses ménages à venir avec l'heure de début (sans l'intervenant) et les logements sous surveillance. Désactivez-le si le client en abuse.</span>
            </span>
          </label>
        </div>
      </div>
    )}
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
      <div><label className="fl">Nom</label><input value={f.name||''} onChange={e=>set('name',e.target.value)}/></div>
      <div><label className="fl">Enseigne <span style={{fontWeight:400,color:'var(--si)',fontSize:10}}>(optionnel — nom commercial affiché dans son espace)</span></label><input value={f.enseigne||''} onChange={e=>set('enseigne',e.target.value)} placeholder="ex: My Sweet Homes"/></div>
      <div><label className="fl">Téléphone</label><input value={f.phone||''} onChange={e=>set('phone',e.target.value)}/></div>
      <div><label className="fl">Email</label><input type="email" value={f.email||''} onChange={e=>set('email',e.target.value)}/></div>
      <div><label className="fl">SIRET</label><input value={f.siret||''} onChange={e=>set('siret',e.target.value)}/></div>
      <div><label className="fl">N° TVA <span style={{fontWeight:400,color:'var(--si)',fontSize:10}}>(optionnel — sociétés)</span></label><input value={f.tva||''} onChange={e=>set('tva',e.target.value)} placeholder="ex: FR52943325951"/></div>
      <div><label className="fl">Taux services %</label><input type="number" value={f.mgr||''} onChange={e=>set('mgr',Number(e.target.value))}/></div>
      <div style={{gridColumn:'1/-1'}}><label className="fl">Adresse (ligne 1)</label><input value={f.addr||''} onChange={e=>set('addr',e.target.value)} placeholder="12 rue des Marchands"/></div>
      <div><label className="fl">Code postal</label><input value={f.cp||''} onChange={e=>set('cp',e.target.value)} placeholder="68000"/></div>
      <div><label className="fl">Ville</label><input value={f.ville||''} onChange={e=>set('ville',e.target.value)} placeholder="Colmar"/></div>
    </div>
    {/* Accès secondaires : un même profil propriétaire peut être consulté par plusieurs
        personnes (ex. le propriétaire + sa secrétaire), chacune avec son propre compte. */}
    <div style={{background:'var(--bg)',borderRadius:10,padding:'12px 14px'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8,flexWrap:'wrap',gap:6}}>
        <div>
          <div style={{fontWeight:700,fontSize:13}}>Accès secondaires</div>
          <div style={{fontSize:11,color:'var(--si)',marginTop:2}}>Personnes supplémentaires pouvant consulter ce profil (secrétaire, comptable…). Chaque accès a son propre mot de passe. Le « Prénom (accueil) » personnalise le message de bienvenue affiché à cette personne (sinon, accueil neutre sans nom).</div>
        </div>
        <button type="button" onClick={addAcces} className="btn bgh sm" style={{fontSize:11}}>+ Ajouter un accès</button>
      </div>
      {acces.length===0?(
        <div style={{fontSize:11,color:'var(--si)',fontStyle:'italic'}}>Aucun accès secondaire.</div>
      ):(
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {acces.map((a,i)=>(
            <div key={i} style={{display:'grid',gridTemplateColumns:'1.3fr 0.9fr 0.9fr auto',gap:6,alignItems:'end'}}>
              <div><label className="fl" style={{fontSize:10}}>Email</label><input type="email" value={a.email||''} onChange={e=>updAcces(i,'email',e.target.value)} placeholder="secretaire@exemple.fr"/></div>
              <div><label className="fl" style={{fontSize:10}}>Libellé</label><input value={a.label||''} onChange={e=>updAcces(i,'label',e.target.value)} placeholder="Secrétaire"/></div>
              <div><label className="fl" style={{fontSize:10}}>Prénom (accueil)</label><input value={a.prenom||''} onChange={e=>updAcces(i,'prenom',e.target.value)} placeholder="ex: Daniel"/></div>
              <button type="button" onClick={()=>rmAcces(i)} className="btn bgh sm" style={{color:'var(--dg)',fontSize:13,padding:'6px 10px'}} title="Retirer cet accès">🗑️</button>
            </div>
          ))}
          <div style={{fontSize:10,color:'var(--si)',lineHeight:1.5}}>⚠️ Après avoir enregistré, créez le compte correspondant dans Supabase (Add user) avec exactement ce même email.</div>
        </div>
      )}
    </div>
    <div><label className="fl">Notes</label><textarea rows="2" value={f.notes||''} onChange={e=>set('notes',e.target.value)}/></div>
    {/* Garantie net minimum par nuit */}
    <div style={{background:'#e8f4ff',borderRadius:10,padding:'12px 14px',border:'1px solid #bfdbfe'}}>
      <div style={{fontWeight:700,fontSize:13,marginBottom:4}}>💰 Garantie nette minimale</div>
      <div style={{fontSize:11,color:'var(--si)',marginBottom:10,lineHeight:1.5}}>
        Si le revenu net du propriétaire (versement OTA − frais de services) est inférieur à ce seuil par nuit, une remise est automatiquement appliquée sur les frais de services.
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
        <div>
          <label className="fl">Seuil minimum (€/nuit net)</label>
          <input type="number" min="0" step="1" value={f.garantieNuiteMin||''} onChange={e=>set('garantieNuiteMin',e.target.value?Number(e.target.value):'')} placeholder="ex: 50 (laisser vide = désactivé)"/>
        </div>
        <div>
          <label className="fl">Libellé de la remise</label>
          <input value={f.remiseLabel||''} onChange={e=>set('remiseLabel',e.target.value)} placeholder="Remise fidélité (défaut)"/>
        </div>
      </div>
    </div>
    {/* Suivi des statuts : active l'onglet "Statut des appartements" dans l'espace propriétaire.
        Désactivé par défaut — à activer uniquement pour les clients réguliers (Pierre-Yves, Delphine).
        Sans intérêt pour les clients occasionnels qui n'ont pas de suivi opérationnel continu. */}
    <div style={{background:'#f0faf4',borderRadius:10,padding:'12px 14px',border:'1.5px solid #86efac'}}>
      <label style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer'}}>
        <input type="checkbox" checked={!!f.suiviStatut} onChange={e=>set('suiviStatut',e.target.checked)} style={{width:16,height:16,cursor:'pointer',flexShrink:0}}/>
        <span>
          <strong style={{fontSize:13}}>🏠 Activer le suivi des statuts</strong>
          <span style={{display:'block',fontSize:11,color:'var(--si)',marginTop:2,lineHeight:1.4}}>
            Affiche un onglet « Statut » dans l'espace propriétaire : état temps réel de chaque logement (occupé, à nettoyer, prêt…), fils de commentaires partagés. À activer pour les clients avec un suivi régulier.
          </span>
        </span>
      </label>
    </div>
    <div style={{display:'flex',gap:8,justifyContent:'flex-end',paddingTop:8}}><button onClick={onC} className="btn bgh">Annuler</button><button onClick={()=>onSave(f)} className="btn bpk">Enregistrer</button></div>
  </div>);
}

// ══════════════ SECTION ANALYSES ══════════════
function SecAnalyses(P){
  const{staff,prov,biens,st,pj,tc,als,clients,rep,gerants}=P;
  const[sub,setSub]=useState('t');
  const[per,setPer]=useState(7);
  const tData=useMemo(()=>{
    const cut=new Date(Date.now()-per*86400000);
    return staff.map(s=>{
      const cl=tc.filter(c=>c.sid===s.id&&new Date(c.date)>=cut);
      const tasks=st.filter(t=>t.sid===s.id&&new Date(t.date)>=cut);
      const planM=tasks.reduce((sum,t)=>sum+t.dm,0);
      let rMs=0,bMs=0,paB=[];
      cl.forEach(c=>{if(c.sw&&c.ew){rMs+=new Date(c.ew.ts)-new Date(c.sw.ts);const allBreaks=getBreaks(c);allBreaks.forEach(b=>{if(b.end){const dms=new Date(b.end)-new Date(b.start);bMs+=dms;if(dms>75*60000)paB.push({date:c.date,dm:Math.round(dms/60000)});}});}});
      const rM=rMs/60000,diff=rM-planM,pM=bMs/60000;
      const eff=planM>0?Math.min(200,Math.round((rM/planM)*100)):null;
      return{...s,planM,rM,pM,diff,eff,paB,dw:cl.filter(c=>c.sw).length};
    });
  },[staff,tc,st,per]);
  const cData=useMemo(()=>{
    // Calcul aligné avec WeekPlan via le helper caTask :
    // - Revenu (rev) : uniquement les tâches affectées à un travailleur existant (salarié OU gérant), tarif selon type + tarif urgent + majoration + extras du rapport
    // - Coût MO salariés (lab) : durée réelle (si dispo) ou planifiée × taux chargé (toutes les tâches)
    // - Coût MO presta (pc) : missions done × tarif horaire prestataire
    // Les sous-traitances aux prestataires ne sont pas comptées dans le revenu (à revoir).
    const validStaffIds=new Set([...staff,...(gerants||[])].map(s=>s.id));
    return biens.map(b=>{
      const cut=new Date(Date.now()-per*86400000);
      const tasks=st.filter(t=>t.bid===b.id&&new Date(t.date)>=cut);
      // Étape 1B : taux horaire du contrat en vigueur À LA DATE DE LA TÂCHE.
      // Sur une fenêtre glissante (30/90/365 j), lire le taux actuel réécrivait
      // rétroactivement la marge de toutes les périodes passées à chaque
      // revalorisation de salaire.
      let lab=0;tasks.forEach(t=>{const s=staff.find(x=>x.id===t.sid);const rMs=t.rs&&t.re?new Date(t.re)-new Date(t.rs):t.dm*60000;const tx=Number(contratActif(s,t.date)?.hr)||0;lab+=(rMs/3600000)*tx*1.45;});
      const jobs=pj.filter(j=>j.bid===b.id&&new Date(j.date)>=cut&&j.st==='done');
      let pc=0;jobs.forEach(j=>{const p=prov.find(x=>x.id===j.pid);if(p?.rt==='h')pc+=(j.dm||60)/60*(p.rate||0);});
      const rev=tasks.filter(t=>t.sid&&validStaffIds.has(t.sid)).reduce((sum,t)=>sum+caTask(t,b,rep),0);
      const tot=lab+pc,mg=rev-tot,mgp=rev>0?Math.round((mg/rev)*100):null;
      return{...b,lab,pc,tot,rev,mg,mgp,nb:tasks.length+jobs.length};
    });
  },[biens,st,pj,staff,prov,per,rep,gerants]);
  const totR=cData.reduce((s,b)=>s+b.rev,0),totC=cData.reduce((s,b)=>s+b.tot,0),totM=totR-totC;
  const mxT=Math.max(...tData.map(d=>Math.max(d.planM,d.rM,d.pM)),1);
  const mxC=Math.max(...cData.map(d=>Math.max(d.tot,d.rev)),1);
  return(<div>
    <div className="stabs">
      <button className={`st ${sub==='t'?'on':''}`} onClick={()=>setSub('t')}><Ic n="cl"/>Temps de travail</button>
      <button className={`st ${sub==='c'?'on':''}`} onClick={()=>setSub('c')}><Ic n="eu"/>Coûts / marge</button>
    </div>
    <div style={{display:'flex',gap:5,marginBottom:18,alignItems:'center'}}>
      <span style={{fontSize:11,color:'var(--si)',fontWeight:600}}>Période :</span>
      {[[7,'7j'],[14,'14j'],[30,'30j']].map(([n,l])=><button key={n} onClick={()=>setPer(n)} className={`btn sm ${per===n?'bor':'bgh'}`}>{l}</button>)}
    </div>
    {sub==='t'&&(<div>
      <div className="card" style={{padding:'18px 20px',marginBottom:16}}>
        <div className="D" style={{fontSize:16,marginBottom:12}}>Temps planifié vs réel (min)</div>
        <div className="bwrap">
          {tData.map(d=>(<div key={d.id} className="bgrp">
            <div className="bcnt">
              <div className="bar" style={{height:`${(d.planM/mxT)*150}px`,background:'var(--mn)',flex:1,opacity:.7}} title={`Planifié : ${Math.round(d.planM)} min`}/>
              <div className="bar" style={{height:`${(d.rM/mxT)*150}px`,background:d.rM>d.planM*1.2?'var(--dg)':'var(--or)',flex:1}} title={`Réel : ${Math.round(d.rM)} min`}/>
              <div className="bar" style={{height:`${(d.pM/mxT)*150}px`,background:'var(--ye)',flex:1,opacity:.85}} title={`Pause : ${Math.round(d.pM)} min`}/>
            </div>
            <div className="blbl">{d.name.split(' ')[0]}</div>
          </div>))}
        </div>
        <div style={{display:'flex',gap:14,marginTop:10,fontSize:11,flexWrap:'wrap'}}>
          <span><span style={{display:'inline-block',width:10,height:10,borderRadius:2,background:'var(--mn)',opacity:.7,marginRight:3}}/> Planifié</span>
          <span><span style={{display:'inline-block',width:10,height:10,borderRadius:2,background:'var(--or)',marginRight:3}}/> Réel</span>
          <span><span style={{display:'inline-block',width:10,height:10,borderRadius:2,background:'var(--ye)',opacity:.85,marginRight:3}}/> Pause</span>
        </div>
      </div>
      <div style={{overflowX:'auto'}}>
        <table className="tbl">
          <thead><tr><th>Salarié</th><th>Jours</th><th>Planifié</th><th>Réel</th><th>Écart</th><th>Pauses</th><th>Efficacité</th><th>⚠ Pauses {">"}75 min</th></tr></thead>
          <tbody>
            {tData.map(d=>(<tr key={d.id}>
              <td><strong>{d.name}</strong></td>
              <td>{d.dw}</td>
              <td>{d.planM>0?`${Math.round(d.planM)} min`:'—'}</td>
              <td style={{fontWeight:700,color:d.rM>0?'var(--ok)':'var(--si)'}}>{d.rM>0?`${Math.round(d.rM)} min`:'—'}</td>
              <td style={{fontWeight:700,color:d.diff>0?'var(--or)':d.diff<-30?'var(--dg)':'var(--ok)'}}>{d.planM>0&&d.rM>0?(d.diff>0?'+':'')+Math.round(d.diff)+' min':'—'}</td>
              <td style={{color:d.pM>d.dw*75?'var(--dg)':'var(--si)'}}>{d.pM>0?`${Math.round(d.pM)} min`:'—'}</td>
              <td>{d.eff!=null&&<div style={{display:'flex',alignItems:'center',gap:5}}><div style={{width:50,height:5,background:'#e0e0e0',borderRadius:999,overflow:'hidden'}}><div style={{width:`${Math.min(100,d.eff)}%`,height:'100%',background:d.eff>120?'var(--dg)':d.eff>100?'var(--or)':'var(--mn)',borderRadius:999}}/></div><span style={{fontSize:12,fontWeight:700,color:d.eff>120?'var(--dg)':d.eff>100?'var(--or)':'var(--ok)'}}>{d.eff}%</span></div>}</td>
              <td>{d.paB.length>0?<div style={{fontSize:11,color:'var(--dg)',fontWeight:600}}>{d.paB.map((p,i)=><div key={i}>⚠ {fd(p.date)} : {p.dm}min</div>)}</div>:<span style={{color:'var(--ok)'}}>✓ OK</span>}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
      <div className="card" style={{padding:'12px 15px',marginTop:12,background:'#fff4d6',border:'1.5px solid var(--ye)'}}><div style={{fontWeight:700,fontSize:12,marginBottom:4}}>📖 Lecture</div><div style={{fontSize:11,color:'var(--si)',lineHeight:1.6}}><strong>Efficacité &gt;120%</strong> → temps réel très supérieur au planning (déplacements, difficultés récurrentes). <strong>Pause &gt;75 min</strong> → anomalie. <strong>Écart positif</strong> = déplacements inter-appartements (normal, raisonnable).</div></div>
    </div>)}
    {sub==='c'&&(<div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:12,marginBottom:18}}>
        {[{l:'Revenu total',v:feur(totR),c:'var(--mn)',e:'💰'},{l:'Coût MO total',v:feur(totC),c:'var(--or)',e:'💼'},{l:'Marge brute',v:feur(totM),c:totM>=0?'var(--ok)':'var(--dg)',e:totM>=0?'📈':'📉'},{l:'Marge %',v:totR>0?Math.round((totM/totR)*100)+'%':'—',c:totM>=0?'var(--ok)':'var(--dg)',e:'%'}].map((k,i)=>(
          <div key={i} className="scard" style={{borderTop:`3px solid ${k.c}`}}>
            <div style={{fontSize:20,marginBottom:5}}>{k.e}</div>
            <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)',marginBottom:3}}>{k.l}</div>
            <div className="D" style={{fontSize:24,color:k.c}}>{k.v}</div>
          </div>
        ))}
      </div>
      <div className="card" style={{padding:'18px 20px',marginBottom:16}}>
        <div className="D" style={{fontSize:16,marginBottom:12}}>Coût MO vs Revenu par appartement</div>
        <div className="bwrap">
          {cData.map(b=>(<div key={b.id} className="bgrp">
            <div className="bcnt">
              <div className="bar" style={{height:`${(b.lab/mxC)*150}px`,background:'var(--bl)',flex:1}} title={`MO salariés : ${feur(b.lab)}`}/>
              <div className="bar" style={{height:`${(b.pc/mxC)*150}px`,background:'var(--or)',flex:1}} title={`MO presta : ${feur(b.pc)}`}/>
              <div className="bar" style={{height:`${(b.rev/mxC)*150}px`,background:'var(--mn)',flex:1,opacity:.8}} title={`Revenu : ${feur(b.rev)}`}/>
            </div>
            <div className="blbl">{b.name.split(' ')[0]}</div>
          </div>))}
        </div>
        <div style={{display:'flex',gap:14,marginTop:10,fontSize:11,flexWrap:'wrap'}}>
          <span><span style={{display:'inline-block',width:10,height:10,borderRadius:2,background:'var(--bl)',marginRight:3}}/> MO salariés</span>
          <span><span style={{display:'inline-block',width:10,height:10,borderRadius:2,background:'var(--or)',marginRight:3}}/> MO presta</span>
          <span><span style={{display:'inline-block',width:10,height:10,borderRadius:2,background:'var(--mn)',opacity:.8,marginRight:3}}/> Revenu</span>
        </div>
      </div>
      <div style={{overflowX:'auto'}}>
        <table className="tbl">
          <thead><tr><th>Appartement</th><th>Propriétaire</th><th>Ménages</th><th>MO salariés</th><th>MO presta</th><th>Coût total</th><th>Revenu</th><th>Marge</th><th>Marge %</th></tr></thead>
          <tbody>
            {cData.map(b=>{const c=clients.find(x=>x.id===b.cid);return(<tr key={b.id}>
              <td><strong>{b.name}</strong></td>
              <td style={{color:'var(--pk)',fontWeight:600}}>{c?.name||'—'}</td>
              <td>{b.nb}</td>
              <td style={{color:'var(--bl)',fontWeight:600}}>{feur(b.lab)}</td>
              <td style={{color:'var(--or)',fontWeight:600}}>{feur(b.pc)}</td>
              <td style={{fontWeight:700}}>{feur(b.tot)}</td>
              <td style={{fontWeight:700,color:'var(--ok)'}}>{feur(b.rev)}</td>
              <td style={{fontWeight:700,color:b.mg>=0?'var(--ok)':'var(--dg)'}}>{feur(b.mg)}</td>
              <td>{b.mgp!=null&&<div style={{display:'flex',alignItems:'center',gap:5}}><div style={{width:46,height:5,background:'#e0e0e0',borderRadius:999,overflow:'hidden'}}><div style={{width:`${Math.max(0,Math.min(100,b.mgp))}%`,height:'100%',background:b.mgp>=30?'var(--ok)':b.mgp>=0?'var(--ye)':'var(--dg)',borderRadius:999}}/></div><span style={{fontSize:11,fontWeight:700,color:b.mgp>=30?'var(--ok)':b.mgp>=0?'var(--ol)':'var(--dg)'}}>{b.mgp}%</span></div>}</td>
            </tr>);})}
          </tbody>
          <tfoot><tr><td colSpan={3}>Total</td><td style={{color:'var(--bl)'}}>{feur(cData.reduce((s,b)=>s+b.lab,0))}</td><td style={{color:'var(--or)'}}>{feur(cData.reduce((s,b)=>s+b.pc,0))}</td><td style={{fontWeight:800}}>{feur(totC)}</td><td style={{color:'var(--ok)',fontWeight:800}}>{feur(totR)}</td><td style={{color:totM>=0?'var(--ok)':'var(--dg)',fontWeight:800}}>{feur(totM)}</td><td><strong style={{color:totM>=0?'var(--ok)':'var(--dg)'}}>{totR>0?Math.round((totM/totR)*100)+'%':'—'}</strong></td></tr></tfoot>
        </table>
      </div>
      <div className="card" style={{padding:'12px 15px',marginTop:12,background:'#e1f7ee',border:'1.5px solid var(--mn)'}}><div style={{fontWeight:700,fontSize:12,marginBottom:4}}>💡 Interprétation</div><div style={{fontSize:11,color:'var(--si)',lineHeight:1.6}}>Coûts MO calculés avec taux chargé (×1,45). Temps réels utilisés si disponibles, sinon planifiés. <strong>Marge ≥30%</strong> = prestation rentable. En dessous de 0% = la prestation coûte plus qu'elle rapporte.</div></div>
    </div>)}
  </div>);
}

// ══════════════ MODULE FACTURATION ══════════════
// Données séjours : { id, bid, cid, dateArrivee, dateDepart, adultes, enfants, nuitees, ota,
//   versementOTA, fraisOTA, fraisMenageLocataire, taxeSejour, versementProprio,
//   baseServices, parures2p, parures1p, debours:[{label,montant}], mois, annee }
export const SEJOUR_EMPTY={
  id:'',bid:'',cid:'',dateArrivee:'',dateDepart:'',adultes:2,enfants:0,nuitees:1,
  nomLocataire:'',nationalite:'',
  ota:'BOOKING',versementOTA:0,fraisOTA:0,fraisMenageLocataire:0,taxeSejour:0,taxeCollecteeParOTA:false,nonAssujettiTS:false,
  versementProprio:0,baseServices:0,parures2p:0,parures1p:0,
  checkinFacture:false,checkoutFacture:false,
  menageUrgent:false,menageDimanche:false,
  debours:[],prestationsSupp:[],ajustementOTA:0,ajustementOTALibelle:'',statut:'draft',
  // import Eviivo (iCal) : source='eviivo' + uid stable + statut 'a_completer' tant que non finalisé par l'admin
  source:'manuel',eviivoUid:null
};
const OTA_LIST=['BOOKING','AIRBNB','EXPEDIA','VRBO','DIRECT','AUTRE'];

function calcSejour(s,bien,client){
  const fraisMenage=Number(s.fraisMenageLocataire||0);
  // Si le séjour est non assujetti à la taxe de séjour, la taxe est forcée à 0 partout
  // (le montant éventuellement saisi est ignoré dans tous les calculs).
  const taxe=s.nonAssujettiTS?0:Number(s.taxeSejour||0);
  const ajustementOTA=Number(s.ajustementOTA||0); // signé : négatif = déduction (réclamation, remboursement…)
  // Versement propriétaire RECALCULÉ depuis les champs sources (jamais depuis s.versementProprio
  // stocké, qui peut être périmé/désynchronisé). Une seule source de vérité.
  // Si taxe collectée par l'OTA : elle est déjà dans le versement voyageur → on la déduit ici.
  // Si taxe réglée à l'arrivée : elle n'est pas passée par l'OTA → on ne la déduit pas du versement.
  const vProprioBrut=s.taxeCollecteeParOTA
    ?Number(s.versementOTA||0)-Number(s.fraisOTA||0)-taxe
    :Number(s.versementOTA||0)-Number(s.fraisOTA||0);
  const vProprio=vProprioBrut+ajustementOTA; // l'ajustement OTA réduit le versement net
  // Base de calcul frais de services = versement propriétaire net − frais ménage.
  // La taxe de séjour n'entre JAMAIS dans la base :
  //  - taxe collectée par l'OTA : déjà retirée du versement voyageur en amont (vProprioBrut) ;
  //  - taxe réglée à l'arrivée : le versement voyageur ne l'a jamais contenue.
  // Dans les deux cas, on ne soustrait pas `taxe` ici (sinon double déduction / déduction indue).
  const base=vProprio-fraisMenage;
  const tauxServices=Number(bien?.tauxGestion||15)/100;
  const fraisServices=(bien?.prestations||[]).includes('gestion')?Math.round(base*tauxServices*100)/100:0;
  const menageBase=(bien?.prestations||[]).includes('menage')?Number(bien?.cp||0):0;
  // Majorations ménage : urgent (montant fixe) + dimanche (% sur le ménage de base)
  const majUrgent=s.menageUrgent?Number(bien?.tarifUrgent||0):0;
  const majDimanche=s.menageDimanche?Math.round(menageBase*Number(bien?.tarifUrgentPct||0)/100*100)/100:0;
  const menage=menageBase+majUrgent+majDimanche;
  const checkin=(bien?.prestations||[]).includes('checkin')&&s.checkinFacture?Number(bien?.tarifCheckin||0):0;
  const checkout=(bien?.prestations||[]).includes('checkout')&&s.checkoutFacture?Number(bien?.tarifCheckout||0):0;
  const linge2p=Number(bien?.tarifLinge2p||0)*Number(s.parures2p||0);
  const linge1p=Number(bien?.tarifLinge1p||0)*Number(s.parures1p||0);
  const kit=(bien?.prestations||[]).includes('kitAccueil')?Number(bien?.tarifKitAccueil||0):(bien?.prestations||[]).includes('packBienvenue')?Number(bien?.tarifPackBienvenue||0):0;
  const totalPrestations=menage+checkin+checkout+linge2p+linge1p+kit;
  const totalDebours=(s.debours||[]).reduce((acc,d)=>acc+Number(d.montant||0),0);
  const totalPrestSupp=(s.prestationsSupp||[]).reduce((acc,p)=>acc+Number(p.montant||0),0);
  const totalHT=totalPrestations+fraisServices+totalDebours+totalPrestSupp;
  const tva=Math.round((totalHT-totalDebours)*0.20*100)/100;
  const totalTTC=Math.round((totalHT+tva)*100)/100;
  // Prix de la nuitée : formule déplacée dans utils.js (prixNuitee) car le calendrier des
  // séjours l'affiche aussi. Source unique — ne pas réintroduire le calcul ici.
  const nuitees=Number(s.nuitees||1);
  const prixNuitee=prixNuiteeHelper(s);

  // ── Garantie nette minimale par nuit ──
  // Si le client a un seuil défini et que le revenu net propriétaire est inférieur,
  // on applique une remise sur les frais de services (plafonné à fraisServices pour rester ≥ 0).
  // netProprio = vProprio − totalTTC  (ce que le proprio touche réellement après nos frais)
  // €/nuit net = netProprio / nuitees
  const garantieNuiteMin=Number(client?.garantieNuiteMin||0);
  let remiseProprio=0;
  let remiseLabel='';
  if(garantieNuiteMin>0&&nuitees>0){
    const netProprio=Math.round((vProprio-totalTTC)*100)/100;
    const seuilTotal=Math.round(garantieNuiteMin*nuitees*100)/100;
    if(netProprio<seuilTotal){
      remiseProprio=Math.min(Math.round((seuilTotal-netProprio)*100)/100,fraisServices);
      remiseLabel=(client?.remiseLabel||'').trim()||'Remise fidélité';
    }
  }
  // Recalcul avec remise appliquée sur fraisServices
  const fraisServicesNet=Math.round((fraisServices-remiseProprio)*100)/100;
  const totalHTNet=totalPrestations+fraisServicesNet+totalDebours+totalPrestSupp;
  const tvaNet=Math.round((totalHTNet-totalDebours)*0.20*100)/100;
  const totalTTCNet=Math.round((totalHTNet+tvaNet)*100)/100;

  return{base,vProprio,ajustementOTA,fraisServices,fraisServicesNet,remiseProprio,remiseLabel,menageBase,majUrgent,majDimanche,menage,checkin,checkout,linge2p,linge1p,kit,totalPrestations,totalDebours,totalPrestSupp,totalHT:totalHTNet,tva:tvaNet,totalTTC:totalTTCNet,prixNuitee};
}

// Construit un snapshot figé des lignes d'une facture, au moment de l'émission.
// Le PDF se régénère ensuite à partir de ce snapshot, JAMAIS des séjours vivants.
// Ainsi, modifier un séjour après émission ne change plus la facture émise.
function buildFactureSnapshot(lignesIds,sejours,biens,clients){
  return (lignesIds||[]).map(id=>{
    const s=(sejours||[]).find(x=>x.id===id);
    if(!s)return null;
    const bien=(biens||[]).find(b=>b.id===s.bid)||{};
    const client=(clients||[]).find(c=>c.id===s.cid);
    const calc=calcSejour(s,bien,client);
    // On fige une copie profonde du séjour, du calcul ET du bien (nom + tarifs linge utilisés dans le PDF)
    return{s:JSON.parse(JSON.stringify(s)),calc:JSON.parse(JSON.stringify(calc)),bien:JSON.parse(JSON.stringify(bien))};
  }).filter(Boolean);
}

// Régénère le PDF d'une facture. Si la facture a un snapshot figé (émise après ajout du
// mécanisme), on l'utilise → le PDF ne bouge jamais, même si les séjours changent ensuite.
// Sinon (factures anciennes sans snapshot), on retombe sur les lignes vivantes fournies.
function regenererPDFDepuisFacture(fac,client,fallbackLignes,periodeInfos){
  const pFichier=(fac.periodeLabel||'facture').replace(/\s+/g,'_').replace(/[^a-zA-Z0-9_\-]/g,'');
  // Facture prestations : on régénère depuis les sections figées sur la facture (gabarit prestations).
  if(fac.profil==='prestations'){
    return generateFacturX({
      client,
      periodeLabel:fac.periodeLabel||'',
      periodeFichier:pFichier,
      periode:periodeInfos||fac.periode||null,
      numeroOverride:fac.numeroDefinitif,
      gabarit:'prestations',
      sections:fac.sectionsPresta||[],
      titrePrefixe:fac.titrePrefixe||'Interventions ',
    });
  }
  const lignes=(fac.snapshotLignes&&fac.snapshotLignes.length)
    ?fac.snapshotLignes
    :fallbackLignes;
  return generateFacturX({
    client,
    lignes,
    periodeLabel:fac.periodeLabel||'',
    periodeFichier:pFichier,
    periode:periodeInfos||fac.periode||null,
    numeroOverride:fac.numeroDefinitif,
  });
}


// Génère le PDF Factur-X d'une facture (snapshot prioritaire) SANS le télécharger,
// puis l'envoie en pièce jointe via l'Edge Function send-invoice-email (Brevo).
// destinataires : tableau d'emails. periodeLabel sert à l'objet du mail.
export async function envoyerFactureParEmail(fac,client,fallbackLignes,destinataires,clientNom,formulePolitesse,signaturePerso){
  const pFichier=(fac.periodeLabel||'facture').replace(/\s+/g,'_').replace(/[^a-zA-Z0-9_\-]/g,'');
  let res;
  if(fac.profil==='prestations'){
    res=await generateFacturX({
      client,
      periodeLabel:fac.periodeLabel||'',
      periodeFichier:pFichier,
      periode:fac.periode||null,
      numeroOverride:fac.numeroDefinitif,
      gabarit:'prestations',
      sections:fac.sectionsPresta||[],
      titrePrefixe:fac.titrePrefixe||'Interventions ',
      returnBlob:true,
    });
  }else{
    const lignes=(fac.snapshotLignes&&fac.snapshotLignes.length)?fac.snapshotLignes:fallbackLignes;
    res=await generateFacturX({
      client,
      lignes,
      periodeLabel:fac.periodeLabel||'',
      periodeFichier:pFichier,
      periode:fac.periode||null,
      numeroOverride:fac.numeroDefinitif,
      returnBlob:true,
    });
  }
  if(!res||!res.bytes)throw new Error('PDF non généré.');
  const pdfBase64=bytesToBase64(res.bytes);
  const periode=fac.periodeLabel||'';
  // Formule de politesse : nom personnalisé saisi par l'admin (ex. « Madame Martin »),
  // sinon on retombe sur le nom du propriétaire tel quel (jamais juste le 1er mot).
  const salut=(formulePolitesse||'').trim()||clientNom||client?.name||'';
  const signature=(signaturePerso||'').trim()||'La Conciergerie';
  const subject=`Votre facture La Conciergerie${periode?(' — '+periode):''}`;
  // Corps HTML — vocabulaire conforme. Le libellé juridique complet reste sur le PDF Factur-X ;
  // l'email d'accompagnement utilise la forme courte « nos prestations ».
  const htmlContent=
    '<div style="font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#2a2520;line-height:1.6;">'
    +`<p>Bonjour${salut?(' '+salut):''},</p>`
    +`<p>Veuillez trouver ci-joint votre facture pour nos prestations${periode?(' sur la période '+periode):''}.</p>`
    +'<p>Le détail figure dans le document joint. Vous pouvez également retrouver l\u2019ensemble de vos locations, factures et rapports dans votre espace personnel :</p>'
    +'<p style="margin:10px 0;"><a href="https://app.conciergerie-alsace.com" target="_blank" style="display:inline-block;background:#FF8617;color:#ffffff;text-decoration:none;font-weight:bold;padding:11px 22px;border-radius:10px;font-size:14px;">Accéder à mon espace</a></p>'
    +'<p>Pour toute question, vous pouvez répondre directement à cet email.</p>'
    +`<p style="margin-top:18px;">Bien cordialement,<br><strong>${signature.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</strong><br><span style="color:#6b5d52;font-size:12px;">Service de conciergerie — Colmar, Alsace</span></p>`
    +'</div>';

  const results=[];
  for(const toEmail of destinataires){
    const r=await fetch(`${SUPA_URL}/functions/v1/send-invoice-email`,{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'Authorization':`Bearer ${SUPA_TOKEN||SUPA_KEY}`,
        'apikey':SUPA_KEY,
      },
      body:JSON.stringify({
        toEmail,
        toName:clientNom||client?.name||'',
        subject,
        htmlContent,
        pdfBase64,
        pdfFilename:res.fileName,
        replyTo:'client@conciergerie-alsace.com',
      }),
    });
    const data=await r.json().catch(()=>({}));
    results.push({email:toEmail,ok:r.ok,error:r.ok?null:(data?.error||data?.details?.message||`HTTP ${r.status}`)});
  }
  return results;
}

// Recalcule le montant TTC ACTUEL d'une facture (snapshot figé si présent, sinon séjours vivants).
// Garantit que la carte affiche le même montant que le PDF régénéré.
function montantFactureActuel(fac,sejours,biens){
  // Facture externe : montant saisi manuellement, pas de lignes séjour
  if(fac.type==='externe') return Math.round(Number(fac.montantTTC||0)*100)/100;
  // Facture prestations : le montant est figé sur l'objet (sections déjà groupées, pas de séjours).
  if(fac.profil==='prestations') return Math.round(Number(fac.montantTTC||0)*100)/100;
  let lignes;
  if(fac.snapshotLignes&&fac.snapshotLignes.length){
    lignes=fac.snapshotLignes;
  }else{
    const ids=new Set(fac.lignesIds||[]);
    lignes=(sejours||[]).filter(s=>ids.has(s.id)).map(s=>{
      const bien=(biens||[]).find(b=>b.id===s.bid)||{};
      return{calc:calcSejour(s,bien)};
    });
  }
  const ttc=lignes.reduce((a,l)=>a+Number(l.calc?.totalTTC||0),0);
  return Math.round(ttc*100)/100;
}

// ── Formulaire de saisie d'un séjour ──
function SejourForm({s,biens,clients,rep,st,feries,sejours,onSave,onC}){
  const[f,setF]=useState(s||{...SEJOUR_EMPTY});
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const bien=biens.find(b=>b.id===f.bid);
  const clientSej=(clients||[]).find(c=>c.id===f.cid);
  const calc=bien?calcSejour(f,bien,clientSej):{};

  // ── Indicateurs majorations (info uniquement, pas d'auto-cochage) ──
  const infoMajorations=React.useMemo(()=>{
    if(!f.bid||!f.dateDepart) return null;
    const b=biens.find(x=>x.id===f.bid);
    if(!b||(b.prestations||[]).indexOf('menage')===-1) return null;
    const dateStr=f.dateDepart;
    const d=new Date(dateStr+'T12:00:00');
    const estDimanche=d.getDay()===0;
    const estFerie=(feries||[]).includes(dateStr);
    const sejourArrivant=(sejours||[]).find(x=>x.id!==f.id&&x.bid===f.bid&&x.dateArrivee===dateStr);
    return{estDimanche,estFerie,sejourArrivant:!!sejourArrivant};
  },[f.bid,f.dateDepart,biens,feries,sejours]);

  // ── Logique de matching ménage suivant ──────────────────────────────────────
  const menageRapport = React.useMemo(()=>{
    if(!f.bid||!f.dateDepart) return null;
    const candidats=(rep||[]).filter(r=>r.bid===f.bid&&r.sub&&r.date>=f.dateDepart);
    if(!candidats.length) return null;
    return candidats.sort((a,b)=>a.date.localeCompare(b.date))[0];
  },[f.bid,f.dateDepart,rep]);

  const menageTache = React.useMemo(()=>{
    if(menageRapport||!f.bid||!f.dateDepart) return null;
    const candidats=(st||[]).filter(t=>t.bid===f.bid&&t.type==='menage'&&t.date>=f.dateDepart);
    if(!candidats.length) return null;
    return candidats.sort((a,b)=>a.date.localeCompare(b.date))[0];
  },[f.bid,f.dateDepart,st,menageRapport]);

  // Extras du rapport avec leur mapping bf
  const extrasRapport = React.useMemo(()=>{
    if(!menageRapport||!bien?.bf) return [];
    const bf=bien.bf||[];
    return bf.map(item=>{
      const val=menageRapport.bill?.[item.id];
      if(val===undefined||val===false||val===null||val==='') return null;
      return{...item, valeur: item.t==='n'?Number(val):1};
    }).filter(Boolean);
  },[menageRapport,bien]);

  const menageJour = menageRapport?.date||menageTache?.date;
  const menageAlerteDecalage = menageJour&&menageJour>f.dateDepart;

  // Import parures (avec mapping)
  const importerParure=(item)=>{
    const champCible=item.menageLie;
    const valActuelle=Number(f[champCible]||0);
    const nouvelleVal=item.valeur;
    if(valActuelle>0&&valActuelle!==nouvelleVal){
      if(!window.confirm(`"${item.lb}" = ${nouvelleVal}\n\nLa valeur actuelle est ${valActuelle}.\nÉcraser ?`)) return;
    }
    set(champCible,nouvelleVal);
  };

  // Import prestation supplémentaire (sans mapping)
  const importerPrestSupp=(item)=>{
    const montant=item.t==='n'?item.valeur*item.tu:item.tu;
    const nouvellePresta={id:'ps'+Date.now(),label:item.lb,montant:String(montant)};
    // Vérifie si une prestation avec le même libellé existe déjà
    const existeDeja=(f.prestationsSupp||[]).some(p=>p.label===item.lb);
    if(existeDeja){
      if(!window.confirm(`"${item.lb}" est déjà dans les prestations supplémentaires.\nAjouter quand même ?`)) return;
    }
    setF(x=>({...x,prestationsSupp:[...(x.prestationsSupp||[]),nouvellePresta]}));
  };

  // Recalcul automatique versementProprio et baseServices
  // Si OTA collecte la taxe : elle est déjà déduite du versement OTA → vProprio = versementOTA − fraisOTA − taxeSejour
  // Si taxe collectée à l'arrivée : OTA ne la touche pas → vProprio = versementOTA − fraisOTA
  // Si séjour non assujetti : taxe effective = 0 (montant saisi ignoré)
  // ajustementOTA (signé, négatif = déduction) vient corriger le versement propriétaire après coup
  const ajustementOTA=Number(f.ajustementOTA||0);
  const taxeEff=f.nonAssujettiTS?0:Number(f.taxeSejour||0);
  const vProprio=(f.taxeCollecteeParOTA
    ?Number(f.versementOTA||0)-Number(f.fraisOTA||0)-taxeEff
    :Number(f.versementOTA||0)-Number(f.fraisOTA||0))+ajustementOTA;
  // Base frais de services = versement propriétaire − frais ménage locataire.
  // La taxe de séjour (qui appartient à la mairie) n'entre jamais dans la base :
  //  - collectée par l'OTA : déjà retirée de vProprio ci-dessus ;
  //  - réglée à l'arrivée : jamais incluse dans le versement voyageur.
  const base=vProprio-Number(f.fraisMenageLocataire||0);

  // Calcul automatique des nuitées depuis les dates
  const nuitéesAuto=useMemo(()=>{
    if(!f.dateArrivee||!f.dateDepart)return null;
    const diff=Math.round((new Date(f.dateDepart)-new Date(f.dateArrivee))/(1000*60*60*24));
    return diff>0?diff:null;
  },[f.dateArrivee,f.dateDepart]);
  // Sync nuitées auto dans le state
  useEffect(()=>{if(nuitéesAuto!==null)setF(x=>({...x,nuitees:nuitéesAuto}));},[nuitéesAuto]);

  const addDebours=()=>setF(x=>({...x,debours:[...(x.debours||[]),{id:'d'+Date.now(),label:'',montant:''}]}));
  const setDebours=(idx,k,v)=>setF(x=>({...x,debours:x.debours.map((d,i)=>i===idx?{...d,[k]:v}:d)}));
  const delDebours=idx=>setF(x=>({...x,debours:x.debours.filter((_,i)=>i!==idx)}));
  const addPrestSupp=()=>setF(x=>({...x,prestationsSupp:[...(x.prestationsSupp||[]),{id:'ps'+Date.now(),label:'',montant:''}]}));
  const setPrestSupp=(idx,k,v)=>setF(x=>({...x,prestationsSupp:x.prestationsSupp.map((p,i)=>i===idx?{...p,[k]:v}:p)}));
  const delPrestSupp=idx=>setF(x=>({...x,prestationsSupp:x.prestationsSupp.filter((_,i)=>i!==idx)}));

  return(<div style={{display:'flex',flexDirection:'column',gap:16}}>
    {/* Bien + dates */}
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
      <div style={{gridColumn:'1/-1'}}><label className="fl">Appartement *</label>
        <select value={f.bid||''} onChange={e=>{const b=biens.find(x=>x.id===e.target.value);set('bid',e.target.value);if(b)set('cid',b.cid||'');}}>
          <option value="">— Sélectionner —</option>
          {biens.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      </div>
      <div><label className="fl">Date d'arrivée *</label><input type="date" value={f.dateArrivee||''} onChange={e=>set('dateArrivee',e.target.value)}/></div>
      <div><label className="fl">Date de départ *</label><input type="date" value={f.dateDepart||''} onChange={e=>set('dateDepart',e.target.value)}/></div>
      <div><label className="fl">Adultes</label><input type="number" min="1" value={f.adultes||1} onChange={e=>set('adultes',Number(e.target.value))} style={{maxWidth:100}}/></div>
      <div><label className="fl">Enfants</label><input type="number" min="0" value={f.enfants||0} onChange={e=>set('enfants',Number(e.target.value))} style={{maxWidth:100}}/></div>
      <div><label className="fl">Nuitées</label>
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <input type="number" min="1" value={f.nuitees||1} onChange={e=>set('nuitees',Number(e.target.value))} style={{maxWidth:100}}/>
          {nuitéesAuto!==null&&<span style={{fontSize:11,color:'var(--ok)',fontWeight:600}}>✓ calculées auto</span>}
        </div>
      </div>
      <div><label className="fl">Plateforme OTA</label>
        <select value={f.ota||'BOOKING'} onChange={e=>set('ota',e.target.value)}>
          {OTA_LIST.map(o=><option key={o}>{o}</option>)}
        </select>
      </div>
      <div><label className="fl">Nom du locataire</label><input value={f.nomLocataire||''} onChange={e=>set('nomLocataire',e.target.value)} placeholder="ex: SCHMIDT Mélanie"/></div>
      <div><label className="fl">Nationalité</label>
        <select value={f.nationalite||''} onChange={e=>set('nationalite',e.target.value)}>
          <option value="">— Sélectionner —</option>
          {[{c:'AF',n:'Afghanistan'},{c:'ZA',n:'Afrique du Sud'},{c:'AL',n:'Albanie'},{c:'DZ',n:'Algérie'},{c:'DE',n:'Allemagne'},{c:'AD',n:'Andorre'},{c:'AO',n:'Angola'},{c:'SA',n:'Arabie Saoudite'},{c:'AR',n:'Argentine'},{c:'AM',n:'Arménie'},{c:'AU',n:'Australie'},{c:'AT',n:'Autriche'},{c:'AZ',n:'Azerbaïdjan'},{c:'BE',n:'Belgique'},{c:'BJ',n:'Bénin'},{c:'BY',n:'Biélorussie'},{c:'BO',n:'Bolivie'},{c:'BA',n:'Bosnie-Herzégovine'},{c:'BR',n:'Brésil'},{c:'BG',n:'Bulgarie'},{c:'BF',n:'Burkina Faso'},{c:'CM',n:'Cameroun'},{c:'CA',n:'Canada'},{c:'CL',n:'Chili'},{c:'CN',n:'Chine'},{c:'CY',n:'Chypre'},{c:'CO',n:'Colombie'},{c:'KR',n:'Corée du Sud'},{c:'CR',n:'Costa Rica'},{c:'HR',n:'Croatie'},{c:'CU',n:'Cuba'},{c:'DK',n:'Danemark'},{c:'EG',n:'Égypte'},{c:'AE',n:'Émirats arabes unis'},{c:'EC',n:'Équateur'},{c:'ES',n:'Espagne'},{c:'EE',n:'Estonie'},{c:'ET',n:'Éthiopie'},{c:'US',n:'États-Unis'},{c:'FI',n:'Finlande'},{c:'FR',n:'France'},{c:'GA',n:'Gabon'},{c:'GE',n:'Géorgie'},{c:'GH',n:'Ghana'},{c:'GR',n:'Grèce'},{c:'GT',n:'Guatemala'},{c:'GN',n:'Guinée'},{c:'GY',n:'Guyane'},{c:'HT',n:'Haïti'},{c:'HN',n:'Honduras'},{c:'HU',n:'Hongrie'},{c:'HK',n:'Hong Kong'},{c:'IN',n:'Inde'},{c:'ID',n:'Indonésie'},{c:'IQ',n:'Irak'},{c:'IR',n:'Iran'},{c:'IE',n:'Irlande'},{c:'IS',n:'Islande'},{c:'IL',n:'Israël'},{c:'IT',n:'Italie'},{c:'CI',n:"Côte d'Ivoire"},{c:'JM',n:'Jamaïque'},{c:'JP',n:'Japon'},{c:'JO',n:'Jordanie'},{c:'KZ',n:'Kazakhstan'},{c:'KE',n:'Kenya'},{c:'KW',n:'Koweït'},{c:'LV',n:'Lettonie'},{c:'LB',n:'Liban'},{c:'LY',n:'Libye'},{c:'LI',n:'Liechtenstein'},{c:'LT',n:'Lituanie'},{c:'LU',n:'Luxembourg'},{c:'MK',n:'Macédoine du Nord'},{c:'MG',n:'Madagascar'},{c:'MY',n:'Malaisie'},{c:'MW',n:'Malawi'},{c:'MV',n:'Maldives'},{c:'ML',n:'Mali'},{c:'MT',n:'Malte'},{c:'MA',n:'Maroc'},{c:'MU',n:'Maurice'},{c:'MX',n:'Mexique'},{c:'MD',n:'Moldavie'},{c:'MC',n:'Monaco'},{c:'MN',n:'Mongolie'},{c:'ME',n:'Monténégro'},{c:'MZ',n:'Mozambique'},{c:'NA',n:'Namibie'},{c:'NP',n:'Népal'},{c:'NI',n:'Nicaragua'},{c:'NE',n:'Niger'},{c:'NG',n:'Nigeria'},{c:'NO',n:'Norvège'},{c:'NZ',n:'Nouvelle-Zélande'},{c:'OM',n:'Oman'},{c:'UG',n:'Ouganda'},{c:'UZ',n:'Ouzbékistan'},{c:'PK',n:'Pakistan'},{c:'PA',n:'Panama'},{c:'PY',n:'Paraguay'},{c:'NL',n:'Pays-Bas'},{c:'PE',n:'Pérou'},{c:'PH',n:'Philippines'},{c:'PL',n:'Pologne'},{c:'PT',n:'Portugal'},{c:'QA',n:'Qatar'},{c:'CF',n:'Rép. centrafricaine'},{c:'CG',n:'Rép. du Congo'},{c:'CD',n:'Rép. dém. du Congo'},{c:'DO',n:'Rép. dominicaine'},{c:'RO',n:'Roumanie'},{c:'GB',n:'Royaume-Uni'},{c:'RU',n:'Russie'},{c:'RW',n:'Rwanda'},{c:'SN',n:'Sénégal'},{c:'RS',n:'Serbie'},{c:'SL',n:'Sierra Leone'},{c:'SK',n:'Slovaquie'},{c:'SI',n:'Slovénie'},{c:'SO',n:'Somalie'},{c:'SD',n:'Soudan'},{c:'SS',n:'Soudan du Sud'},{c:'LK',n:'Sri Lanka'},{c:'SE',n:'Suède'},{c:'CH',n:'Suisse'},{c:'SY',n:'Syrie'},{c:'TW',n:'Taïwan'},{c:'TZ',n:'Tanzanie'},{c:'TD',n:'Tchad'},{c:'CZ',n:'Tchéquie'},{c:'TH',n:'Thaïlande'},{c:'TG',n:'Togo'},{c:'TN',n:'Tunisie'},{c:'TR',n:'Turquie'},{c:'UA',n:'Ukraine'},{c:'UY',n:'Uruguay'},{c:'VE',n:'Venezuela'},{c:'VN',n:'Viêt Nam'},{c:'YE',n:'Yémen'},{c:'ZM',n:'Zambie'},{c:'ZW',n:'Zimbabwe'},{c:'XX',n:'Autre'}].map(p=><option key={p.c} value={p.c}>{p.c} — {p.n}</option>)}
        </select>
      </div>
    </div>

    {/* Bandeau lien ménage */}
    {(menageRapport||menageTache)&&(<div style={{background:menageAlerteDecalage?'#fff4e0':'#efffef',borderRadius:10,padding:'12px 14px',border:`1.5px solid ${menageAlerteDecalage?'#f59e0b':'var(--ok)'}`}}>
      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
        <span style={{fontSize:16}}>{menageRapport?'🧹':'📋'}</span>
        <span style={{fontWeight:700,fontSize:13,color:menageAlerteDecalage?'#b45309':'var(--ok)'}}>
          {menageRapport?'Rapport de ménage soumis':'Ménage planifié'} — {menageJour}
        </span>
        {menageAlerteDecalage&&<span style={{fontSize:10,background:'#f59e0b',color:'#fff',padding:'1px 7px',borderRadius:999,fontWeight:700}}>⚠️ J+{Math.round((new Date(menageJour)-new Date(f.dateDepart))/(864e5))} — à valider</span>}
      </div>
      {menageRapport&&extrasRapport.length>0&&(<div>
        <div style={{fontSize:11,color:'var(--si)',marginBottom:6}}>Extras cochés par le salarié :</div>
        <div style={{display:'flex',flexDirection:'column',gap:5}}>
          {extrasRapport.map(item=>(<div key={item.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',background:'var(--wh)',borderRadius:7,padding:'6px 10px',border:'1px solid var(--li)'}}>
            <div style={{display:'flex',alignItems:'center',gap:7}}>
              <span style={{fontSize:15}}>{item.em||'💰'}</span>
              <span style={{fontSize:12,fontWeight:600}}>{item.lb}</span>
              <span style={{fontSize:11,color:'var(--si)'}}>× {item.valeur}</span>
              {item.tu>0&&<span style={{fontSize:11,color:'var(--or)',fontWeight:600}}>{item.t==='n'?`${feur(item.valeur*item.tu)}`:`${feur(item.tu)}`}</span>}
            </div>
            {item.menageLie?(
              <button type="button" onClick={()=>importerParure(item)} className="btn bor sm" style={{fontSize:11,padding:'3px 9px'}}>
                📥 → {item.menageLie==='parures2p'?'Parures 2p':'Parures 1p'}
              </button>
            ):(
              <button type="button" onClick={()=>importerPrestSupp(item)} className="btn bmn sm" style={{fontSize:11,padding:'3px 9px'}}>
                📥 → Prestation supp.
              </button>
            )}
          </div>))}
        </div>
      </div>)}
      {menageRapport&&extrasRapport.length===0&&<div style={{fontSize:12,color:'var(--si)',fontStyle:'italic'}}>Aucun extra coché dans ce rapport.</div>}
      {!menageRapport&&menageTache&&<div style={{fontSize:12,color:'var(--si)',fontStyle:'italic'}}>Le rapport n'a pas encore été soumis par le salarié.</div>}
    </div>)}

    {/* Flux financiers */}
    <div style={{background:'var(--cr)',borderRadius:10,padding:'14px 16px'}}>
      <div style={{fontWeight:700,fontSize:13,marginBottom:12}}>💰 Flux financiers (depuis Eviivo / OTA)</div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
        <div><label className="fl">Versement voyageur à l'OTA (€)</label><input type="number" min="0" step="0.01" value={f.versementOTA||''} onChange={e=>set('versementOTA',e.target.value)}/></div>
        <div><label className="fl">Frais de service OTA (€)</label><input type="number" min="0" step="0.01" value={f.fraisOTA||''} onChange={e=>set('fraisOTA',e.target.value)}/></div>
        <div><label className="fl">Frais ménage payés par locataire (€)</label><input type="number" min="0" step="0.01" value={f.fraisMenageLocataire||''} onChange={e=>set('fraisMenageLocataire',e.target.value)}/><div style={{fontSize:10,color:'var(--si)',marginTop:3}}>Ce que le locataire paie à la plateforme pour le ménage — ne vous est pas reversé</div></div>
        <div>
          <label className="fl">Taxe de séjour collectée (€)</label>
          <input type="number" min="0" step="0.01" value={f.nonAssujettiTS?'':(f.taxeSejour||'')} disabled={!!f.nonAssujettiTS} onChange={e=>set('taxeSejour',e.target.value)} style={f.nonAssujettiTS?{background:'var(--li)',color:'var(--si)',cursor:'not-allowed'}:undefined}/>
          <label style={{display:'flex',alignItems:'center',gap:6,marginTop:6,cursor:f.nonAssujettiTS?'not-allowed':'pointer',fontSize:11,opacity:f.nonAssujettiTS?.5:1}}>
            <input type="checkbox" checked={!!f.taxeCollecteeParOTA} disabled={!!f.nonAssujettiTS} onChange={e=>set('taxeCollecteeParOTA',e.target.checked)} style={{width:14,height:14}}/>
            <span style={{color:'var(--si)'}}>Collectée par l'OTA <span style={{color:'var(--or)',fontWeight:600}}>(déjà déduite du versement)</span></span>
          </label>
          <label style={{display:'flex',alignItems:'center',gap:6,marginTop:6,cursor:'pointer',fontSize:11}}>
            <input type="checkbox" checked={!!f.nonAssujettiTS} onChange={e=>set('nonAssujettiTS',e.target.checked)} style={{width:14,height:14}}/>
            <span style={{color:'var(--si)'}}>Non assujetti à la taxe de séjour <span style={{color:'var(--bl)',fontWeight:600}}>(taxe forcée à 0)</span></span>
          </label>
        </div>
      </div>
      {/* Calcul automatique */}
      <div style={{marginTop:12,paddingTop:12,borderTop:'1px solid rgba(42,37,32,.1)',display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,fontSize:12}}>
        <div style={{background:'var(--wh)',borderRadius:7,padding:'7px 10px'}}>
          <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>Versement OTA → Propriétaire</div>
          <div style={{fontWeight:700,color:'var(--ok)',fontSize:14}}>{feur(Math.max(0,vProprio))}</div>
          <div style={{fontSize:10,color:'var(--si)'}}>= Versement voyageur − Frais OTA{f.taxeCollecteeParOTA?<span style={{color:'var(--or)'}}> − Taxe séjour (déduite par l'OTA)</span>:<span style={{color:'var(--bl)'}}> · taxe collectée à l'arrivée (hors OTA)</span>}</div>
        </div>
        <div style={{background:'var(--wh)',borderRadius:7,padding:'7px 10px'}}>
          <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'.06em',color:'var(--si)'}}>Base de calcul services</div>
          <div style={{fontWeight:700,color:'var(--or)',fontSize:14}}>{feur(Math.max(0,base))}</div>
          <div style={{fontSize:10,color:'var(--si)'}}>= Versement propriétaire − Frais ménage <span style={{color:'var(--si)'}}>(taxe de séjour hors base)</span></div>
        </div>
      </div>

      {/* Ajustement OTA (réclamation, remboursement imposé par l'OTA après coup) */}
      <div style={{marginTop:12,paddingTop:12,borderTop:'1px dashed #c2410c'}}>
        <div style={{fontSize:11,fontWeight:700,color:'#c2410c',textTransform:'uppercase',letterSpacing:'.04em',marginBottom:6}}>⚠️ Ajustement OTA (cas exceptionnel)</div>
        <div style={{fontSize:11,color:'var(--si)',marginBottom:8}}>Déduction imposée par l'OTA après le séjour (réclamation client, remboursement…). Saisir un montant <b>négatif</b> pour une déduction. Réduit le versement propriétaire <b>et</b> votre commission.</div>
        <div style={{display:'grid',gridTemplateColumns:'130px 1fr',gap:8}}>
          <div>
            <label className="fl">Montant (€)</label>
            <input type="number" step="0.01" value={f.ajustementOTA||''} placeholder="ex: -166.86"
              onChange={e=>set('ajustementOTA',e.target.value)}
              style={{borderColor:Number(f.ajustementOTA||0)!==0?'#c2410c':undefined}}/>
          </div>
          <div>
            <label className="fl">Motif (visible sur le récap propriétaire)</label>
            <input type="text" value={f.ajustementOTALibelle||''} placeholder="ex: Réclamation client Booking"
              onChange={e=>set('ajustementOTALibelle',e.target.value)}/>
          </div>
        </div>
        {Number(f.ajustementOTA||0)!==0&&(
          <div style={{fontSize:11,color:'#c2410c',marginTop:6,fontWeight:600}}>
            Ajustement appliqué : {feur(Number(f.ajustementOTA||0))} → versement propriétaire net : {feur(Math.max(0,vProprio))}
          </div>
        )}
      </div>
    </div>

    {/* Bandeau info majorations */}
    {infoMajorations&&(infoMajorations.estDimanche||infoMajorations.estFerie||infoMajorations.sejourArrivant)&&<div style={{background:'#fffbeb',borderRadius:9,padding:'10px 14px',border:'1px solid #f59e0b',display:'flex',flexDirection:'column',gap:5}}>
      <div style={{fontWeight:700,fontSize:12,color:'#92400e',marginBottom:2}}>ℹ️ Infos sur ce départ</div>
      {infoMajorations.estDimanche&&<div style={{fontSize:12,color:'#78350f'}}>☀️ Ce départ tombe un <strong>dimanche</strong> — pensez à cocher la majoration ci-dessous si applicable.</div>}
      {!infoMajorations.estDimanche&&infoMajorations.estFerie&&<div style={{fontSize:12,color:'#78350f'}}>🏳️ Ce départ tombe un <strong>jour férié</strong> — pensez à cocher la majoration ci-dessous si applicable.</div>}
      {infoMajorations.estDimanche&&infoMajorations.estFerie&&<div style={{fontSize:12,color:'#78350f'}}>🏳️ Ce jour est aussi un <strong>jour férié</strong>.</div>}
      {infoMajorations.sejourArrivant&&<div style={{fontSize:12,color:'#78350f'}}>⚡ Un séjour <strong>arrive ce même jour</strong> sur ce bien — ménage urgent probable.</div>}
    </div>}

    {/* Majorations ménage */}
    {bien&&(bien?.prestations||[]).includes('menage')&&(Number(bien?.tarifUrgent||0)>0||Number(bien?.tarifUrgentPct||0)>0)&&<div style={{background:'#fff4d6',borderRadius:10,padding:'12px 14px',border:'1.5px solid var(--ye)'}}>
      <div style={{fontWeight:700,fontSize:12,marginBottom:10}}>⚡ Majorations ménage</div>
      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {Number(bien?.tarifUrgent||0)>0&&<label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:13}}>
          <input type="checkbox" checked={!!f.menageUrgent} onChange={e=>set('menageUrgent',e.target.checked)} style={{width:16,height:16}}/>
          <span>Ménage urgent <strong style={{color:'var(--or)'}}>+ {feur(Number(bien.tarifUrgent))}</strong> <span style={{fontSize:11,color:'var(--si)'}}>(check-out suivi d'un check-in le même jour)</span></span>
        </label>}
        {Number(bien?.tarifUrgentPct||0)>0&&<label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:13}}>
          <input type="checkbox" checked={!!f.menageDimanche} onChange={e=>set('menageDimanche',e.target.checked)} style={{width:16,height:16}}/>
          <span>Dimanche / jour férié <strong style={{color:'var(--or)'}}>+ {bien.tarifUrgentPct}%</strong> <span style={{fontSize:11,color:'var(--si)'}}>sur le tarif ménage ({feur(Math.round(Number(bien.cp||0)*Number(bien.tarifUrgentPct||0)/100*100)/100)})</span></span>
        </label>}
      </div>
    </div>}

    {/* Linge */}
    {bien&&((bien?.prestations||[]).includes('checkin')||(bien?.prestations||[]).includes('checkout'))&&<div style={{background:'var(--bg)',borderRadius:10,padding:'12px 14px',border:'1px solid var(--li)'}}>
      <div style={{fontWeight:700,fontSize:12,marginBottom:10}}>🔑 Accueil & remise des clés</div>
      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {(bien?.prestations||[]).includes('checkin')&&<label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:13}}>
          <input type="checkbox" checked={!!f.checkinFacture} onChange={e=>set('checkinFacture',e.target.checked)} style={{width:16,height:16}}/>
          <span>Facturer le check-in <strong style={{color:'var(--or)'}}>{feur(Number(bien.tarifCheckin||0))}</strong></span>
        </label>}
        {(bien?.prestations||[]).includes('checkout')&&<label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:13}}>
          <input type="checkbox" checked={!!f.checkoutFacture} onChange={e=>set('checkoutFacture',e.target.checked)} style={{width:16,height:16}}/>
          <span>Facturer le check-out <strong style={{color:'var(--or)'}}>{feur(Number(bien.tarifCheckout||0))}</strong></span>
        </label>}
      </div>
    </div>}

    {/* Linge */}
    {bien&&(bien?.prestations||[]).includes('linge')&&<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
      <div><label className="fl">Parures 2 personnes utilisées</label><input type="number" min="0" value={f.parures2p||0} onChange={e=>set('parures2p',Number(e.target.value))} style={{maxWidth:120}}/>{bien?.tarifLinge2p&&<div style={{fontSize:10,color:'var(--si)',marginTop:3}}>{feur(Number(bien.tarifLinge2p))} / parure</div>}</div>
      <div><label className="fl">Parures 1 personne utilisées</label><input type="number" min="0" value={f.parures1p||0} onChange={e=>set('parures1p',Number(e.target.value))} style={{maxWidth:120}}/>{bien?.tarifLinge1p&&<div style={{fontSize:10,color:'var(--si)',marginTop:3}}>{feur(Number(bien.tarifLinge1p))} / parure</div>}</div>
    </div>}

    {/* Débours */}
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
        <label className="fl" style={{margin:0}}>Débours (taxe séjour, reversements, etc.)</label>
        <button onClick={addDebours} className="btn bgh sm"><Ic n="plus"/>Ajouter</button>
      </div>
      <div style={{fontSize:11,color:'var(--si)',marginBottom:8}}>Montants négatifs : sommes reversées au propriétaire que vous avez encaissées pour son compte.</div>
      {(f.debours||[]).length===0&&<div style={{fontSize:12,color:'var(--si)',fontStyle:'italic',padding:'8px 12px',background:'var(--bg)',borderRadius:8}}>Aucun débours pour ce séjour</div>}
      <div style={{display:'flex',flexDirection:'column',gap:7}}>
        {(f.debours||[]).map((d,i)=><div key={d.id||i} style={{display:'grid',gridTemplateColumns:'1fr auto auto',gap:8,alignItems:'center'}}>
          <input value={d.label||''} onChange={e=>setDebours(i,'label',e.target.value)} placeholder="ex: Taxe de séjour collectée"/>
          <input type="number" step="0.01" value={d.montant||''} onChange={e=>setDebours(i,'montant',e.target.value)} placeholder="-41,98" style={{maxWidth:120}}/>
          <button onClick={()=>delDebours(i)} className="btn bdg sm"><Ic n="trash" c="w-3.5 h-3.5"/></button>
        </div>)}
      </div>
    </div>

    {/* Prestations supplémentaires (TVA 20%) */}
    <div style={{background:'#f0f9ff',borderRadius:10,padding:'12px 14px',border:'1px solid #bae6fd'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
        <label className="fl" style={{margin:0,color:'#0369a1'}}>➕ Prestations supplémentaires <span style={{fontSize:10,fontWeight:400,color:'var(--si)'}}>TVA 20%</span></label>
        <button onClick={addPrestSupp} className="btn bgh sm"><Ic n="plus"/>Ajouter</button>
      </div>
      <div style={{fontSize:11,color:'var(--si)',marginBottom:8}}>Ex : ménage approfondi, présence animal, supplément spa… Ces lignes apparaîtront sur la facture avec TVA 20%.</div>
      {(f.prestationsSupp||[]).length===0&&<div style={{fontSize:12,color:'var(--si)',fontStyle:'italic',padding:'8px 12px',background:'var(--wh)',borderRadius:8}}>Aucune prestation supplémentaire</div>}
      <div style={{display:'flex',flexDirection:'column',gap:7}}>
        {(f.prestationsSupp||[]).map((p,i)=><div key={p.id||i} style={{display:'grid',gridTemplateColumns:'1fr auto auto',gap:8,alignItems:'center'}}>
          <input value={p.label||''} onChange={e=>setPrestSupp(i,'label',e.target.value)} placeholder="ex: Ménage approfondi"/>
          <input type="number" min="0" step="0.01" value={p.montant||''} onChange={e=>setPrestSupp(i,'montant',e.target.value)} placeholder="0,00" style={{maxWidth:120}}/>
          <button onClick={()=>delPrestSupp(i)} className="btn bdg sm"><Ic n="trash" c="w-3.5 h-3.5"/></button>
        </div>)}
      </div>
    </div>

    {/* Aperçu récap */}
    {bien&&calc.totalHT!=null&&<div className="card" style={{padding:'14px 16px',background:'#e1f7ee',border:'1.5px solid var(--mn)'}}>
      <div style={{fontWeight:700,fontSize:13,marginBottom:10}}>Aperçu de la facturation</div>
      {calc.prixNuitee>0&&<div style={{display:'flex',justifyContent:'space-between',fontSize:11,color:'var(--si)',marginBottom:8,padding:'6px 10px',background:'var(--wh)',borderRadius:7}}>
        <span>Prix de la nuitée <span style={{color:'var(--si)',fontStyle:'italic'}}>({f.nuitees} nuit{f.nuitees>1?'s':''})</span></span>
        <strong style={{color:'var(--bl)'}}>{feur(calc.prixNuitee)} / nuit</strong>
      </div>}
      <div style={{display:'flex',flexDirection:'column',gap:5,fontSize:12}}>
        {calc.menageBase>0&&<div style={{display:'flex',justifyContent:'space-between'}}><span>Ménage</span><span>{feur(calc.menageBase)}</span></div>}
        {calc.majUrgent>0&&<div style={{display:'flex',justifyContent:'space-between',color:'var(--or)'}}><span>⚡ Majoration urgent</span><span>+ {feur(calc.majUrgent)}</span></div>}
        {calc.majDimanche>0&&<div style={{display:'flex',justifyContent:'space-between',color:'var(--or)'}}><span>📅 Majoration dimanche/férié</span><span>+ {feur(calc.majDimanche)}</span></div>}
        {calc.checkin>0&&<div style={{display:'flex',justifyContent:'space-between'}}><span>Check-in</span><span>{feur(calc.checkin)}</span></div>}
        {calc.checkout>0&&<div style={{display:'flex',justifyContent:'space-between'}}><span>Check-out</span><span>{feur(calc.checkout)}</span></div>}
        {calc.linge2p>0&&<div style={{display:'flex',justifyContent:'space-between'}}><span>Linge 2p × {f.parures2p}</span><span>{feur(calc.linge2p)}</span></div>}
        {calc.linge1p>0&&<div style={{display:'flex',justifyContent:'space-between'}}><span>Linge 1p × {f.parures1p}</span><span>{feur(calc.linge1p)}</span></div>}
        {calc.kit>0&&<div style={{display:'flex',justifyContent:'space-between'}}><span>Kit accueil / Pack bienvenue</span><span>{feur(calc.kit)}</span></div>}
        {calc.fraisServices>0&&<div style={{display:'flex',justifyContent:'space-between',fontWeight:700,color:'var(--or)'}}><span>Commission de service ({bien?.tauxGestion||15}%)</span><span>{feur(calc.fraisServices)}</span></div>}
        {calc.remiseProprio>0&&<div style={{display:'flex',justifyContent:'space-between',fontWeight:700,color:'var(--ok)'}}><span>🎁 {calc.remiseLabel||'Remise fidélité'}</span><span>−{feur(calc.remiseProprio)}</span></div>}
        {(f.prestationsSupp||[]).filter(p=>p.label&&p.montant).map((p,i)=><div key={i} style={{display:'flex',justifyContent:'space-between',color:'#0369a1'}}><span>➕ {p.label}</span><span>{feur(Number(p.montant))}</span></div>)}
        {(f.debours||[]).filter(d=>d.label&&d.montant).map((d,i)=><div key={i} style={{display:'flex',justifyContent:'space-between',color:'var(--dg)'}}><span>{d.label}</span><span>{feur(Number(d.montant))}</span></div>)}
        <div style={{borderTop:'1.5px solid var(--mn)',marginTop:4,paddingTop:6,display:'flex',justifyContent:'space-between',fontWeight:800,fontSize:13}}><span>Total HT</span><span>{feur(calc.totalHT)}</span></div>
        <div style={{display:'flex',justifyContent:'space-between',color:'var(--si)'}}><span>TVA 20%</span><span>{feur(calc.tva)}</span></div>
        <div style={{display:'flex',justifyContent:'space-between',fontWeight:800,fontSize:14,color:'var(--ok)'}}><span>Total TTC</span><span>{feur(calc.totalTTC)}</span></div>
      </div>
    </div>}

    {/* Commentaire facture */}
    <div style={{background:'var(--bg)',borderRadius:10,padding:'12px 14px',border:'1px solid var(--li)'}}>
      <label className="fl" style={{margin:'0 0 6px'}}>💬 Commentaire sur la facture <span style={{fontSize:10,fontWeight:400,color:'var(--si)'}}>— apparaît en italique sous les lignes du séjour (optionnel)</span></label>
      <textarea rows={2} value={f.noteFact||''} onChange={e=>set('noteFact',e.target.value)} placeholder="ex: Séjour privé hors plateforme, tarif négocié" style={{width:'100%',fontSize:12,resize:'vertical'}}/>
    </div>

    {/* À revalider */}
    <div style={{background:'#fff4e0',borderRadius:10,padding:'12px 14px',border:'1.5px solid #f59e0b'}}>
      <label style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer',fontSize:13}}>
        <input type="checkbox" checked={!!f.aReprendre} onChange={e=>set('aReprendre',e.target.checked)} style={{width:16,height:16,accentColor:'#f59e0b'}}/>
        <span>⚠️ <strong style={{color:'#b45309'}}>À revalider</strong> <span style={{fontSize:11,color:'var(--si)'}}>— éléments manquants (ex : frais OTA définitifs non connus)</span></span>
      </label>
    </div>

    {/* Facturé hors application */}
    <div style={{background:'#f0fdf4',borderRadius:10,padding:'12px 14px',border:'1.5px solid #86efac'}}>
      <label style={{display:'flex',alignItems:'center',gap:10,cursor:'pointer',fontSize:13}}>
        <input type="checkbox" checked={!!f.factureHorsAppli} onChange={e=>set('factureHorsAppli',e.target.checked)} style={{width:16,height:16,accentColor:'#16a34a'}}/>
        <span>✓ <strong style={{color:'#15803d'}}>Facturé hors application</strong> <span style={{fontSize:11,color:'var(--si)'}}>— ce séjour a été facturé manuellement, en dehors de l'appli</span></span>
      </label>
    </div>

    <div style={{display:'flex',gap:8,justifyContent:'flex-end',paddingTop:8}}>
      <button onClick={onC} className="btn bgh">Annuler</button>
      <button onClick={()=>onSave({...f,id:f.id||'sej'+Date.now(),versementProprio:vProprio,baseServices:base})} className="btn bor" disabled={!f.bid||!f.dateArrivee}>Enregistrer</button>
    </div>
  </div>);
}







// ═══════════════════════════════════════════════════════════════════
// FIN SCRIPT 6 — PROPRIÉTÉS & SÉJOURS (SecProp, ClientForm, SejourForm)
// Découpage par frontière naturelle (option douce, zéro déplacement).
// ═══════════════════════════════════════════════════════════════════

export { SecProp, ClientForm, SecAnalyses, calcSejour, buildFactureSnapshot, regenererPDFDepuisFacture, montantFactureActuel, SejourForm };
